import React from 'react';
import { Outlet } from 'react-router-dom';
import {
  useAccount,
  useIsAuthenticated,
  useMsal,
  useMsalAuthentication,
} from '@azure/msal-react';
import { env } from '../../../shared/env';
import { useGetUserQuery } from '../../services/usersSlice';
import { InteractionType } from '@azure/msal-browser';
import { authRequest } from '../../../frontend/app/msal';
import pca from '../../app/msal';

export const Auth = () => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress, accounts } = useMsal();
  const { error: getUserError } = useGetUserQuery('me', {
    skip: !isAuthenticated,
  });

  const { error: msalError, login } = useMsalAuthentication(
    InteractionType.Redirect,
    authRequest
  );
  if (msalError) {
    login(InteractionType.Redirect, authRequest);
  }
  const accountToUse = accounts.find(
    (account) => account.tenantId === env.REACT_APP_TENANT_ID
  );
  const account = useAccount();
  React.useEffect(() => {
    if (!account && accountToUse) {
      // If there is no active account, set one.
      pca.setActiveAccount(accountToUse);
    }
  }, [accountToUse, account]);

  if (msalError) {
    return (
      <p aria-label="Authentication error">
        An authentication error has occurred. Please refresh your browser.
      </p>
    );
  } else if (getUserError) {
    return (
      <>
        <p aria-label="Server error">
          A server error has occurred. Please refresh your browser.
        </p>
      </>
    );
  } else if (inProgress !== 'none') {
    return <p>Redirecting...</p>;
  } else if (isAuthenticated) {
    return <Outlet />;
  } else {
    return (
      <p aria-label="Unknown error">
        An unknown error has occurred. Please refresh your browser.
      </p>
    );
  }
};

export default Auth;
